import script from "./AppSideBarComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppSideBarComponent.vue?vue&type=script&lang=ts&setup=true"

import "./AppSideBarComponent.vue?vue&type=style&index=0&id=77d4992c&lang=scss&scoped=true"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77d4992c"]])

export default __exports__